var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8575 4.10038C5.38535 4.62823 6.24117 4.62823 6.76902 4.10038L9.63662 1.23278C9.98847 0.880932 10.5589 0.880932 10.9108 1.23278C11.2626 1.58463 11.2626 2.15509 10.9108 2.50693L6.76902 6.64869C6.24117 7.17654 5.38535 7.17654 4.8575 6.64869L0.715741 2.50693C0.363893 2.15508 0.363893 1.58463 0.715741 1.23278C1.06759 0.880932 1.63805 0.880932 1.98989 1.23278L4.8575 4.10038Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarr);
export default __webpack_public_path__ + "static/media/downarr.776f1fe8508a4e35c1e89615ada41122.svg";
export { ForwardRef as ReactComponent };